import { useFormContext, useWatch } from "react-hook-form";
import { useIntl } from "react-intl";
import { StopAddressType } from "types/MultiStop";

export default function StopPortCountry({ index }: { index: number }) {
  const intl = useIntl();
  const { control, getValues } = useFormContext();
  const stopAddressType = useWatch({ control, name: `schedule.stops.${index}.stop_address_type` });
  const portCountry = useWatch({ control, name: `schedule.stops.${index}.port_country` });
  const isPortType = stopAddressType === StopAddressType.AIRPORT || stopAddressType === StopAddressType.SEAPORT;

  if (!isPortType || !portCountry) return null;

  return (
    <div className="mb-xl">
      <label>
        {intl.formatMessage({
          id: "general.country",
          defaultMessage: "Country",
        })}
      </label>
      <div className="font-b4">
        <div>{getValues(`schedule.stops.${index}.port_country`)}</div>
      </div>
    </div>
  );
}
